import { useContext } from "react";
import DropCtx from "../context";
import Pc from './pc';
import Mb from './mb';
import { observer } from "mobx-react-lite";
import m from 'skin/store/mb'

export default observer(function Menu({ children, ...props }) {
	const mb = m.isMobile;
	const { open } = useContext(DropCtx);
	if (!open) return null;
	const Cmp = mb ? Mb : Pc;
	return <Cmp children={children} {...props} />
})